module.exports = require('./lib/uslug');


//////////////////
// WEBPACK FOOTER
// ./~/uslug/index.js
// module id = 349
// module chunks = 0